<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="permissionsArray.includes('access_form_email_manager')">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="mb-2 page-title-container">
                        <div class="page-name">Form Email Manager List</div>
                    </div>
                    <div class="pl-0 pr-0 col-md-12 forms-block">
                        <div class="pl-0 col-md-6 col-sm-12 forms-block pr-0 pull-left">
                            <div class="mt-2 pull-left pr-0 pl-0 col-3 paddingleft0">
                                <div class="form-label">Request Options :</div>
                            </div>
                            <div class="pull-right pr-0 pl-0 col-9 paddingleft0">
                                <v-select v-model="formType" name="formType"
                                    label="text"
                                    :options="formMasterArr" :clearable=false>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 pl-0 pr-0 forms-block pull-right">
                            <div class="page-title-container">
                                <div class="pagebutton">
                                    <router-link class="themebutton" title="Add" v-bind:to="{name: 'AddUpdateFormEmailManager'}">
                                        <span>Add</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!-- <br/> -->
                    <vue-good-table
                        ref="FomrEmailMapperList"
                        mode="remote"
                        title="Form Email Mapper List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">
                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            class="pagination-select-box"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <template v-if="props.row.status != 'Close' || loginUserRoleId == 1">
                                        <router-link title='Edit' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdateFormEmailManager', params:{id: props.row.id}}">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </router-link>
                                        <a href="javascript:void(0)" @click="deleteFormEmailManager(props.row.id)" title='Delete' class="btn edit-btn-vvg waves-effect pull-left">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                    </template>
                                </div>
                                <div v-else-if="props.column.field == 'to_email'">
                                    <p v-html="addNewLineInEmailColumn(props.formattedRow['to_email'])"></p>
                                </div>
                                <div v-else-if="props.column.field == 'cc_email'">
                                    <p v-html="addNewLineInEmailColumn(props.formattedRow['cc_email'])"></p>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions">
                            <template>
                            </template>
                        </div>
                    </vue-good-table>   
                </div>
            </div>
        </template>
        <template v-else>
            <no-access></no-access>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../../mixins/commonMixins';
    import {HTTP} from '../../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../../../components/event-bus";
    import NoAccessPage from "@/components/NoAccessPage/NoAccessPage";
    Vue.component("app-footer", Footer);
    Vue.component('no-access', NoAccessPage);
    Vue.use(VueGoodTable);
    var self;
    export default {
        name: 'ListFormEmailManager',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                loginUserRoleId: 1,
                firstLoad: 0,
                formType: "",
                formMasterArr: [],
                columns: [
                    {
                        label: 'Department Name',
                        field: 'department',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location Name',
                        field: 'location_name',
                        filterable: false,
                        sortable: false,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'To Email',
                        field: 'to_email',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "To Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CC Email',
                        field: 'cc_email',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CC Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                    perPageDropdown : [],
                },
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                permissionsArray: ['access_form_email_manager'],
            }
        },
        watch: {
            formType: function(formType) {
                self.laodFormMasterData();
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuActive("ListFormEmailManager");
            self.formMasterData();
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }

            self.jumpToPageTask = self.serverParams.page;
            self.pageCompareTask = Math.ceil(self.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            self.serverParams.perPageDropdown.push(25);
            self.serverParams.perPageDropdown.push(50);
            self.serverParams.perPageDropdown.push(100);
            self.serverParams.perPageDropdown.push(200);
            self.serverParams.perPageDropdown.push(500);
            self.laodFormMasterData();
        },
        methods: {
            formMasterData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                    }
                };
                HTTP.get("/form/manager/get", config)
                        .then(function (response) {
                            self.formMasterArr = response.data.content;
                            self.formType = {text: self.formMasterArr[0].text, value: self.formMasterArr[0].value};
                        })
                        .catch(function (err) {
                            self.catchHandler(err, function () {});
                        });
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.laodFormMasterData();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.laodFormMasterData();
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.laodFormMasterData();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.laodFormMasterData();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('first_name');
                    field: ('last_name');
                    field: ('dtna_connect_id');
                    field: ('employee_no');
                    field: ('company_email');
                    field: ('position');
                    field: ('birth_date');
                    field: ('updated_at');
                    field: ('updated_by');
                };
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.first_name || filters.last_name || filters.dtna_connect_id
                    || filters.employee_no || filters.company_email || filters.position || filters.birth_date
                    || filters.updated_at || filters.updated_by
                ) {
                    self.laodFormMasterData();
                }
            },
            selectionChanged() {
                self.selectedRows = (self.$refs['LocationList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.laodFormMasterData();
            },
            deleteFormEmailManager: function(id) {
                let deleteArray = [];
                id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
                if(id != 0) {
                    deleteArray.push(id);
                } else {
                    var parRequestDeleteArr = [];
                    var selectedPARRequest = this.$refs["FomrEmailMapperList"].selectedRows;
                    for (var i = 0; i < selectedPARRequest.length; i++) {
                        parRequestDeleteArr.push(this.$refs["FomrEmailMapperList"].selectedRows[i].id);
                    }
                    deleteArray = parRequestDeleteArr;
                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to delete this Form Email Mapper(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                            data : {
                                deleteArr: deleteArray,
                            }
                        };
                        HTTP.delete("/form/mapper/delete", config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.laodFormMasterData();
                                }
                            })
                            .catch(function (error) {
                                self.catchHandler(err, function () {});
                            });
                    }
                });
            },
            laodFormMasterData() {
                self.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    formType: self.formType.value
                };
                self.showLoader();
                HTTP.post("/form/mapper/list", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
        },
    };
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/FormEmailManager/ListFormEmailManager.vue